export default __webpack_public_path__ + "static/media/img-user-wallets-4.a66aa403.png";